<template>
  <div class="elevator-navigation">
    <p class="ttile">
      电梯导航<span>(说明:只能选择当前组件下方的组件进行定位)</span>
    </p>
    <div class="set-content">
      <div class="set-item">
        <p class="title">选择类型</p>
        <TypeGroup v-model="curComponent.type" :options="typeOptions" />
      </div>

      <div class="set-item add-img">
        <p class="title">添加标签</p>
        <p class="dec">图片支持.jpg、.gif、png，最多1张，单个图片不超过10M。</p>

        <UploadImgList
          v-model="tags"
          :maxLength="10"
          :haveImg="haveImg"
          :haveTitle="haveTitle"
          jumpType="component"
          addBtnText="添加标签"
          :templateParams="template"
        />
      </div>

      <div class="set-item basic-set">
        <p class="title">样式基础设置</p>
        <SpRadio
          v-model="curComponent.positionType"
          label="固定位置"
          :options="positionOptions"
        />
        <SpRadio
          v-if="curComponent.type === 'elevatorText'"
          v-model="curComponent.way"
          label="展示方式"
          :options="wayOptions"
        />

        <SpPickerColor
          v-model="curComponent.defaultColor"
          defaultColor="#969799"
          label="文本颜色-默认状态"
        />
        <SpPickerColor
          v-model="curComponent.activeColor"
          defaultColor="#000000"
          label="文本颜色-选中状态"
        />
        <SpPickerColor
          v-model="curComponent.backgroundColor"
          :isGradient="true"
          defaultColor="rgba(255,255,255,0)"
          label="背景颜色"
        />
        <!-- v1.2.1新增 - start -->
        <SpSlider
          v-if="haveRadiusFiled"
          v-model="curComponent.radius"
          label="圆角值"
        />
        <SpSlider
          v-if="havePageMxField"
          v-model="curComponent.pageMx"
          label="页面间距"
        />
        <SpSlider
          v-if="haveMbField"
          v-model="curComponent.mb"
          label="页面底部间距"
        />
        <SpSlider
          v-if="
            curComponent.type === 'elevatorImgText' && haveImgTextMarginField
          "
          v-model="curComponent.imgTextMargin"
          :max="15"
          label="图文间距"
        />
        <!-- end -->
      </div>
    </div>
  </div>
</template>

<script>
import TypeGroup from "./components/TypeGroup";
import SpRadio from "../../../components/SpRadio";
import SpSlider from "../../../components/SpSlider";
import UploadImgList from "../../../components/UploadImgList";
import SpPickerColor from "../../../components/SpPickerColor";

import { positionOptions, typeOptions, wayOptions } from "./options";
export default {
  components: {
    SpRadio,
    SpSlider,
    TypeGroup,
    SpPickerColor,
    UploadImgList
  },
  inject: ["control"],
  data() {
    return {
      typeOptions: Object.freeze(typeOptions),
      positionOptions: Object.freeze(positionOptions),
      wayOptions: Object.freeze(wayOptions)
    };
  },
  watch: {
    "curComponent.type": {
      handler(val) {
        if (val !== "elevatorText") {
          this.control.curComponent.way = "row";
        }
      }
    }
  },
  computed: {
    template() {
      const length = this.tags.length + 1;
      const title = this.$convertToChineseNumber(length);
      return {
        path: "",
        imgUrl: "",
        title: `导航${title}`
      };
    },
    haveImg() {
      const { type } = this.curComponent;
      return type !== "elevatorText";
    },
    haveTitle() {
      const { type } = this.curComponent;
      return type !== "elevatorImg";
    },
    tags: {
      get() {
        return this.control.curComponent.tags;
      },
      set(val) {
        this.$set(this.control.curComponent, "tags", val);
      }
    },
    maxLength() {
      return {
        oneLineOne: 1,
        carousel: 10,
        slider: 10
      }[this.curComponent.type];
    },
    curComponent() {
      return this.control.curComponent;
    },
    // v1.2.1新增 - start
    havePageMxField() {
      const flag = "pageMx" in this.curComponent;
      if (!flag) {
        this.$set(this.curComponent, "pageMx", 0);
      }
      return "pageMx" in this.curComponent;
    },
    haveMbField() {
      const flag = "mb" in this.curComponent;
      if (!flag) {
        this.$set(this.curComponent, "mb", 0);
      }
      return "mb" in this.curComponent;
    },
    haveImgTextMarginField() {
      const flag = "imgTextMargin" in this.curComponent;
      if (!flag) {
        this.$set(this.curComponent, "imgTextMargin", 0);
      }
      return "imgTextMargin" in this.curComponent;
    },
    haveRadiusFiled() {
      const flag = "radius" in this.curComponent;
      if (!flag) {
        this.$set(this.curComponent, "radius", 0);
      }
      return "radius" in this.curComponent;
    }
    // end
  }
};
</script>

<style lang="less" scoped>
.elevator-navigation {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      padding-left: 10px;
    }
  }
  > .set-content {
    padding-top: 15px;
    padding: 20px 24px;
    > .set-item {
      > .title {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      > .dec {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-bottom: 20px;
      }
      > .select-view {
        margin-top: 12px;
        > span {
          font-size: 12px;
          font-weight: 400;
        }
        > span:first-child {
          color: #999999;
        }
        > span:last-child {
          color: #333333;
          padding-left: 10px;
        }
      }
    }
    > .add-img {
      margin-top: 30px;
    }

    > .basic-set {
      margin-top: 30px;
      /deep/ .slider-content {
        margin-bottom: 17px;
      }
      /deep/ .picker-color,
      .sp-radio {
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/ElevatorNavigation/Attr.vue